module.exports = __webpack_public_path__ + "img/people-header.7e0adfbf.png";